import { memo } from 'react';
import { Box, FormHelperText } from '@mui/material';
import {
  DynamicFieldType,
  DynamicFormFieldProps,
  DynamicFormFieldWithContext,
} from 'components/DynamicFormField/DynamicFormField';

export type DynamicFieldWrapperProps = {
  child: DynamicFieldType;
  value: any;
  isDisabled: boolean;
  onChange: (name: string, value: any) => void;
  onValidationChange: (fieldName: string, isValid: boolean) => void;
  fieldOptions?: DynamicFormFieldProps['fieldOptions'];
  error?: string;
};

export const DynamicFieldWrapper = memo(
  ({
    child,
    value,
    isDisabled,
    onChange,
    onValidationChange,
    fieldOptions,
    error,
  }: DynamicFieldWrapperProps) => (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: 0,
        ...(error && {
          '& fieldset': { borderColor: 'error.main !important' },
          '& .MuiOutlinedInput-root:hover fieldset': {
            borderColor: 'error.main !important',
          },
          '& .MuiInputLabel-root': { color: 'error.main' },
        }),
      }}
    >
      <DynamicFormFieldWithContext
        fieldConfig={child}
        fieldOptions={fieldOptions}
        value={value}
        onChange={(name, val) => onChange(name, val)}
        onValidationChange={onValidationChange}
        disabled={isDisabled}
      />
      {error && (
        <FormHelperText
          error
          sx={{ mx: '1rem', mt: '1px', mb: 0.75 }}
        >
          {error}
        </FormHelperText>
      )}
    </Box>
  ),
  (prev, next) =>
    prev.value === next.value &&
    prev.isDisabled === next.isDisabled &&
    prev.error === next.error,
);

DynamicFieldWrapper.displayName = 'DynamicFieldWrapper';
